import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay, tap } from 'rxjs';
import { Employee } from '../../models/employee';
import { Generic } from '../../models/generic';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { GenericPaginated } from '../../models/generic-paginated';
import { SIDE_NAV_ITEMS } from '../../models/side-nav-items';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  private baseUrl = environment.url;

  url = environment.url
  employee = signal<Employee | undefined>(undefined);

  private http = inject(HttpClient);
  private addParamsService = inject(AddParamsService)

  private profileRequest$?: Observable<Generic<Employee>>;

  getEmployeesList(params?: Params): Observable<GenericPaginated<Employee>> {
    return this.http.get<GenericPaginated<Employee>>(`${this.baseUrl}/employees`, {
      params: this.addParamsService.addParams(params)
    });
  }

  getEmployeeById = (employeeId: string): Observable<Generic<Employee>> => {
    return this.http.get<Generic<Employee>>(`${this.baseUrl}/employees/${employeeId}`);
  }

  addEmployee = (payload: object): Observable<Employee> => {
    return this.http.post<Employee>(`${this.baseUrl}/employees/create`, payload);
  }

  updateEmployee = (employeeID: number, payload: object): Observable<Employee> => {
    return this.http.patch<Employee>(`${this.baseUrl}/employees/${employeeID}`, payload)
  }

  deleteEmployee = (employeeID: number): Observable<Employee> => {
    return this.http.delete<Employee>(`${this.baseUrl}/employees/${employeeID}`)
  }

  // loadEmployeeProfile = (): Observable<Generic<Employee>> => {
  //   return this.http.get<Generic<Employee>>(`${this.url}/employees/profile`).pipe(
  //     tap((res) => {
  //       this.employee.set(res.data);
  //     })
  //   );
  // }

  loadEmployeeProfile(): Observable<Generic<Employee>> {
    if (!this.profileRequest$) {
      this.profileRequest$ = this.http.get<Generic<Employee>>(`${this.url}/employees/profile`).pipe(
        tap(res => this.employee.set(res.data)),
        shareReplay(1)
      );
    }
    return this.profileRequest$;
  }

  setEmployee = (employee: Employee) => {
    this.employee.set(employee)
  }

  clearEmployee = () => {
    this.employee.set(undefined);
  }

  getFirstAllowedRoute = (): string => {

    const employee = this.employee();
    if (!employee) return '/login';

    for (const item of SIDE_NAV_ITEMS) {

      // Parent route
      if (item.routePath) {
        if (!item.requiredRoles || item.requiredRoles.includes(employee.role)) {
          return item.routePath;
        }
      }

      // Children routes
      // if (item.items) {
      //   for (const child of item.items) {
      //     if (!child.requiredRoles || child.requiredRoles.includes(employee.role)) {
      //       return child.routePath ?? '/dashboard';
      //     }
      //   }
      // }
    }

    return '/login'; // fallback
  }
}
